.container {
	padding: 2rem;
	max-width: 1600px;
	margin: 0 auto;
}

.grid {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 2rem;
	margin-top: 2rem;
}

.card {
	background: white;
	border: 2px solid #e0e0e0;
	border-radius: 12px;
	padding: 2.5rem 2rem;
	text-align: center;
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
		border-color: var(--card-color);

		.iconContainer {
			background-color: var(--card-color);
			color: white;
		}

		.title {
			color: var(--card-color);
		}
	}

	&:active {
		transform: translateY(-2px);
	}
}

.iconContainer {
	width: 80px;
	height: 80px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f5f5;
	color: var(--card-color);
	transition: all 0.3s ease;
	margin-bottom: 0.5rem;
}

.title {
	font-size: 1.25rem;
	font-weight: 600;
	color: #333;
	margin: 0;
	transition: color 0.3s ease;
}

.description {
	font-size: 0.95rem;
	color: #666;
	margin: 0;
	line-height: 1.5;
}

@media (max-width: 1200px) {
	.grid {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 768px) {
	.wrapper {
		padding: 1rem;
	}

	.container {
		padding: 1rem;
	}

	.grid {
		grid-template-columns: 1fr;
		gap: 1.5rem;
	}

	.card {
		padding: 2rem 1.5rem;
	}

	.iconContainer {
		width: 70px;
		height: 70px;

		svg {
			width: 40px;
			height: 40px;
		}
	}

	.title {
		font-size: 1.1rem;
	}

	.description {
		font-size: 0.9rem;
	}
}
